import { cn } from '@/lib/utils';
import type { EnvironmentInfo, EnvironmentTone } from '@/app/environment';

// Tinted strip in the normal text colour, identified by hue; production is a calm inverted bar.
const TONE: Record<EnvironmentTone, string> = {
  development: 'bg-env-development/12 border-env-development/35 text-foreground',
  staging: 'bg-env-staging/12 border-env-staging/35 text-foreground',
  demo: 'bg-env-demo/12 border-env-demo/35 text-foreground',
  production: 'bg-foreground text-background border-foreground',
};

const DOT: Record<EnvironmentTone, string> = {
  development: 'bg-env-development',
  staging: 'bg-env-staging',
  demo: 'bg-env-demo',
  production: 'bg-destructive',
};

/** Always visible, so nobody edits production thinking it is dev. */
export function EnvironmentBanner({ env, className }: { env: EnvironmentInfo; className?: string }) {
  return (
    <div
      role="status"
      aria-label={`Environment: ${env.label}`}
      className={cn('flex h-7 items-center gap-2 border-b px-4 text-xs font-medium', TONE[env.tone], className)}
    >
      <span aria-hidden className={cn('size-2 rounded-full', DOT[env.tone])} />
      {env.label}
    </div>
  );
}
